const headerClass = () => {
  if (scrollY >= 40) {
    document.body.classList.add('header-air')
  } else {
    document.body.classList.remove('header-air')
  }
}

window.addEventListener('scroll', () => headerClass(scrollY))
window.addEventListener('load', () => headerClass(scrollY))

const canvas = document.querySelector('.main-navigation__curve')
const ctx = canvas.getContext('2d')
const width = 1000
const height = 95
canvas.width = width
canvas.height = height

ctx.beginPath()
ctx.moveTo(0, 0)
ctx.lineTo(0, 0)
ctx.quadraticCurveTo(width / 2, height * 2, width, 0)
ctx.lineTo(width, 0)
ctx.fillStyle = '#fff'
ctx.fill()

const hamburger = document.querySelector('.hamburger')
hamburger.addEventListener('click', () =>
  document.body.classList.toggle('menu-active')
)
